import { Box } from "@mui/material";
import { CircularProgress, CircularProgressProps } from "@telegram-apps/telegram-ui";
import { CommonIcon } from "./CommonIcon";

export function CircularProgressWithIcon(
    props: CircularProgressProps & { icon: string },
  ) {
    return (
      <Box sx={{ position: 'relative', display: 'flex' }}>
        <CircularProgress {...props} size="medium" />
        <Box
          sx={{
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            position: 'absolute',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <CommonIcon
            type="filled"
            icon={props.icon}
            size={16}
            color="var(--tgui--link_color)"
          />
        </Box>
      </Box>
    );
  }
